import { User } from "@/graphql/output/graphql";

const userHasPermission = (user: User, permission: string): boolean =>
  user.all_permissions.includes(permission);

export default userHasPermission;
